// extracted by mini-css-extract-plugin
export default {"textFeedback":"text-feedback_textFeedback__qhc8N"};